import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Flow } from 'signup-constants/Flow';
import { SignupEmbedder } from 'signup-embedder';
import { shouldShowEmptyContent } from '../messaging/utils/shouldShowEmptyContent';
import { isFlow } from '../utils/isFlow';
import { Step } from '../views/Step';
import { getAcademyLandingPageNextButtonText, getAcademyLandingPageTitle } from './getAcademyLandingPageText';
export const getLandingPageTitle = flowKey => {
  const stepKey = Step.LandingPage;
  let titleLabel = `views.${stepKey}.title.${flowKey}`;
  let subtitleLabel = `views.${stepKey}.subtitle.${flowKey}`;

  if (isFlow(Flow.Academy)) {
    titleLabel = getAcademyLandingPageTitle(stepKey);
  }

  if (isFlow(Flow.Crm) && shouldShowEmptyContent()) {
    subtitleLabel = `views.${stepKey}.subtitle.acq125_crm`;
  }

  const title = isValidI18nKey(titleLabel) ? titleLabel : `views.${stepKey}.title.generic`;
  return {
    title,
    subtitleLabel
  };
};
export const getLandingPageButton = () => {
  const isEmbedded = SignupEmbedder.isEmbedded(); // check if is Academy Flow and embedded flow

  if (isFlow(Flow.Academy) && isEmbedded) {
    return getAcademyLandingPageNextButtonText(Step.LandingPage);
  }

  return `${Step.LandingPage}.buttonLabel.default`;
};